import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateThemeShift", function updateThemeShift(theme: string) {
    if (shiftEditorViewState().shift) {
        shiftEditorViewState().shift.theme = theme;
    }
});